window.Staff = {

	toggleStatus: function(staffid){

		var options = {action:"toggleStaffStatus", staffid:staffid};

		MyFacture.post("prefsAccount", options, function(data){

            var staff = $('#staff_'+data.response.staffid);

			if (data.response.status == 'ok'){

                staff.find('.statushidden').val(data.response.newStatus);
				$('.nbStaffUsed').html(data.response.nbStaffUsed);

			} else {

                staff.find('input[type=checkbox]').prop('checked', false);

				var winOptions = {
					resizable	: false,
					type		: 'error',
					title		: Loc.g("Erreur"),
					buttons		: [
						{text : Loc.g("Fermer"), click : function(){$(this).dialog("close");}}
					]
				};

                //--- Force checkbox uncheck
                $('#staff_'+data.response.staffid).find('.statuscheckbox').prop('checked', false);

				switch (data.response.more){
					case 'mainstaff':
						var msg = Loc.g("Vous ne pouvez pas désactiver l'administrateur principal.");
						break;

					case 'duplicate_email':
						var msg = Loc.g("Vous ne pouvez pas activer ce collaborateur car son adresse email est déjà utilisée pour un autre collaborateur actif.");
						break;

					case "subscription":
						var msg = Loc.g("Vous avez atteint la limite de collaborateurs de votre abonnement.");

						winOptions.buttons = [
							{
                                text : Loc.g("Gérer votre abonnement"),
                                click : function(){
                                    window.location.href = '/subscription/cart';
                                }
                            },
							{
                                text : Loc.g("Fermer"),
                                click : function(){
                                    $(this).dialog("close");
                                }
                            }
						];

						break;

					case "plan":
						var msg = Loc.g("Vous avez atteint la limite de collaborateurs de votre plan.");

						winOptions.buttons = [
							{
                                text : Loc.g("Changer de plan"),
                                click : function(){
                                    Subscription.upgradeRequest(false)
                                }
                            },
							{
                                text : Loc.g("Fermer"),
                                click : function(){
                                    $(this).dialog("close");
                                }
                            }
						];

						break;
				}

				MyWindow.alert(msg, winOptions);

			}
		}, "json");

	},

	sendStaffPwd: function(staffid){
		var msg =  Loc.g('Vous allez renvoyer un nouveau mot de passe à ce collaborateur.') + '<br /><br />' + Loc.g('Son ancien mot de passe sera désactivé.');
		var options = {
			resizable	: false,
			noclose		: true,
			title		: Loc.g("Renvoi de mot de passe"),
			buttons		: [
				{text : Loc.g("Annuler"), click : function(){$(this).dialog("close");}},
                {text : Loc.g("Valider"), click : function(){Staff.processSendStaffPwd(staffid, $(this));}}
            ]
		};

		MyWindow.alert(msg, options);
	},

	processSendStaffPwd: function(staffid, me){
		var options = {action:"sendStaffPassword", staffid:staffid};
		MyFacture.post("prefsAccount", options, function(data){me.dialog("close");}, "json");
	},

	edit: function(staffid){

			var title = Loc.g('Ajouter un collaborateur');
			if (staffid !== undefined){
				title = Loc.g('Modifier le collaborateur')
			}

			var options = {
				title	: title,
				width: 1000,
				buttons	: [
					{
						text : Loc.g("Annuler"),
						click : function(){
							$(this).dialog("close");
						}
					},
					{
						text : Loc.g("Enregistrer"),
						click : function(){
							$("#staffForm").submit();
						}
					}
				],
				callback	: function(){Staff.prepareEditForm();}
			};

		MyWindow.load("prefsAccount", {action:"staffForm", staffid: staffid, fromLegacy: true}, options);

	},

	prepareEditForm: function(){

		var formId = "staffForm";
		var options = {success:function(data){

			var formIsOk = MyForm.processJson(data, "staffForm");
			if(formIsOk){
				// Ne pas envoyer le mot de passe par mail mais l'afficher
				if (data.displayPwd == 'Y') {

					var options = {
						title	: Loc.g("Mot de passe du collaborateur"),
						closeOnEscape: false,
						close: function(){
							Utils.reload();
						},
						width: 450,
						height: 385,
						buttons	: [
							{
								text : Loc.g("Fermer"),
								'class' : 'btn btn-default',
								click : function(){
									Utils.reload();
								}
							}
						]
					};

					MyWindow.load("prefsAccount", {'action': 'displayPwd', 'staffid':data.staff.id}, options);

				} else {

					Utils.reload();

				}
			}

		}, dataType:"json"};

		MyForm.prepare(formId, "prefsAccount&action=recordStaff", options, true);
		MyFacture.initEvent();

	},


	confirmDeletion: function(staffid){
		var options = {
			resizable	: false,
			noclose		: true,
			type		: "warning",
			width		: 350,
			title		: Loc.g("Suppression d'un collaborateur"),
			buttons		: [
				{text : Loc.g("Annuler"), click : function(){$(this).dialog("close");}},
				{text :
					Loc.g("Supprimer"),
					click : function(){
						$(this).dialog("close");

						var datas = {'action':"deleteStaff", 'staffid':staffid};
						MyFacture.post("prefsAccount", datas, function(data){
							Utils.reload()
						}, "json");
					}
				},
			]
		};

		MyWindow.alert(Loc.g('Vous allez supprimer le compte de ce collaborateur.'), options);
	},

	isDecisionMaker : function (staffid, value) {

		$.ajax({
			url         : '/staff/isDecisionMaker/'+staffid,
			type        : 'PUT',
			dataType    : 'json',
			data 		: {
				value	: value
			},
			async       : false,
			success     : function(){
				$('#alertWindow').dialog("close");
			}
		});

	},

    createForm: function (isCorpSellsy) {
		let isCorpSellsyBool = isCorpSellsy === 'Y';
        window.sellsyapp.config.globalProperties.$store.state.popupPanel.staffForm.props = {fromLegacy: true, isSellsyCorp: isCorpSellsyBool}
		window.sellsyapp.config.globalProperties.$store.state.popupPanel.staffForm.display = true
	},
	updateForm: function (staffid, isCorpSellsy) {
		let isCorpSellsyBool = isCorpSellsy === 'Y';
        window.sellsyapp.config.globalProperties.$store.state.popupPanel.staffForm.props = {staffid : staffid, fromLegacy: true, isSellsyCorp: isCorpSellsyBool}
        window.sellsyapp.config.globalProperties.$store.state.popupPanel.staffForm.display = true
    },
	show2FAModal: function(event) {
		// value here is old value before input update
		const toActivate = !event.children('#prefStaff_activate2FAForCorp').prop('checked')
		window.sellsyapp.config.globalProperties.$store.state.popupPanel.corp2FAToggle.props = {toActivate}
		window.sellsyapp.config.globalProperties.$store.state.popupPanel.corp2FAToggle.display = true
	},

};
